import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRemoveBackground2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="remove-background-2"><path fillRule="evenodd" clipRule="evenodd" d="M12 1C12.4142 1 12.75 1.33579 12.75 1.75V3H19.25C20.2165 3 21 3.7835 21 4.75V19.25C21 20.2165 20.2165 21 19.25 21H12.75V22.25C12.75 22.6642 12.4142 23 12 23C11.5858 23 11.25 22.6642 11.25 22.25V21H4.75C3.7835 21 3 20.2165 3 19.25V4.75C3 3.7835 3.7835 3 4.75 3H11.25V1.75C11.25 1.33579 11.5858 1 12 1ZM8 8H4.5V12H8V16H4.5V19.25C4.5 19.3881 4.61193 19.5 4.75 19.5H8V16H11.25V12H8V8H11.25V4.5H8V8Z" fill="currentColor"/></CentralIconBase>;
};

export default IconRemoveBackground2;
